module.exports = {
  query: `  
  allContentstackCampaign {
    edges {
      node {
        title
        feature_flag
        end_date
        start_date
        unique_id
      }
    }
  }`,
};
